import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state:{
        listInfo:[],
        total:0,
        balanceInfo:[],
        balanceTotal:0,
    },
    mutations:{
        setListInfo(state,payload) {
            state.listInfo = payload;
        },
        setTotal(state,payload) {
            state.total = payload;
        },
        setBalanceInfo(state,payload) {
            state.balanceInfo = payload.list;
            state.balanceTotal = payload.totalCount;
        }
    },
    actions:{
        buildList({commit},data) {
            api.getProjectList(data).then(response => {
                commit('setTotal',response.data.totalCount);
                commit('setListInfo',response.data.list);
            })
        },
        buildBalance({commit},data) {
            api.balanceList(data).then(response =>{
                commit('setBalanceInfo',response.data);
            })
        }
    }
}

appStore.registerModule('project',store);
